"use client";
import { cleanText, formatarData } from "@/lib/utils";
import { ICMSConcurso } from "@/services/types";
import RenderHtmlContentDescritpions from "../common/RenderHtmlContentDescritpions";

interface InformacaoConcursoSectionProps {
    concurso: ICMSConcurso;
}

const InformacaoConcursoSection: React.FC<InformacaoConcursoSectionProps> = ({ concurso }) => {


    // Função para formatar datas (usa formatarData do utils para evitar problemas de timezone)
    const formatDate = (dateString?: string) => {
        if (!dateString) return 'Consultar';
        return formatarData(dateString);
    };

    return (
        <section className="relative w-full mx-auto container flex flex-col px-12 sm:p-6 md:p-8 lg:p-12 xl:p-16">
            {/* Cards em grid - responsivo para diferentes tamanhos de tela */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-6">

                {/* Card: Medidas e Incentivos */}
                <div className="p-4 md:p-4 rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)]  inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
                    <h5 className="text-[#F15A29] text-sm md:text-base font-medium font-poppins">Medidas e Incentivos</h5>
                    <p className="text-gray-600 text-sm md:text-base font-light font-poppins">
                        {concurso.cms_incentivo?.title || concurso.publico_alvo || 'N/A'}
                    </p>
                </div>

                {/* Período de Candidatura */}
                <div className="p-4 md:p-6 rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)]  inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
                    <h3 className="text-[#F15A29] text-sm md:text-base font-medium font-poppins">Prazo para envio de propostas</h3>
                    <p className="text-gray-600 text-sm md:text-base font-light font-poppins">
                        {concurso.prazo_envio_proposta && `${formatDate(concurso.prazo_envio_proposta)}`}
                    </p>
                </div>

                {/* Card: Duração da Formação */}
                <div className="p-4 md:p-4 rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)]  inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
                    <h5 className="text-[#F15A29] text-sm md:text-base font-medium font-poppins">Fonte de Recursos</h5>
                    <p className="text-gray-600 text-sm md:text-base font-light font-poppins">{cleanText(concurso.fonte_recursos)}</p>
                </div>

                <div className="p-4 md:p-6 rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)]  inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
                    <h3 className="text-[#F15A29] text-sm md:text-base font-medium font-poppins">Público-Alvo</h3>
                    <p className="text-gray-600 text-sm md:text-base font-light font-poppins">
                        {concurso.publico_alvo}
                    </p>
                </div>

            </div>

            <div className="w-full px-4 sm:px-4 lg:px-16 py-6">
                <RenderHtmlContentDescritpions htmlContent={concurso?.description || ""} className="font-normal text-xl text-[#2B2F31] text-left sm:text-left md:text-left lg:text-justify"></RenderHtmlContentDescritpions>
            </div>
        </section>);
};

export default InformacaoConcursoSection;